import { useCallback, useMemo } from "react"
import { useMutation } from "@tanstack/react-query"

import { v1SetLocale } from "@be-miniapp/api"
import { i18n } from "@be-miniapp/i18n/init"

import { useClientInfo } from "@/store/client-info"
import { useClientSetting } from "@/store/client-setting"

const useLanguage = () => {
  const setLocale = useClientInfo((state) => state.setLocale)

  const { mutate: changeServerLanguage } = useMutation({
    mutationFn: async (lang: "en" | "vi") => {
      return v1SetLocale({
        updated_locale: lang,
      })
    },
    onSuccess: (resp) => {
      if (resp.flag === 143) {
      } else {
      }
    },
    onError: () => {},
  })

  const language = useClientSetting((state) => state.language)
  const changeClientLanguage = useClientSetting((state) => state.changeLanguage)
  const forceUseLanguage = useClientSetting((state) => state.forceUseLanguage)

  const changeLanguage = useCallback(
    (
      lang: "en" | "vi",
      updateServerLang: boolean = false,
      force: boolean = false
    ) => {
      if (forceUseLanguage && !force) return

      changeClientLanguage(lang)
      setLocale(lang)
      i18n.changeLanguage(lang)

      try {
        updateServerLang && changeServerLanguage(lang)
      } catch (_err) {}
    },
    [changeClientLanguage, changeServerLanguage, setLocale, forceUseLanguage]
  )

  const data = useMemo(() => {
    return {
      language,
      changeLanguage,
    }
  }, [language, changeLanguage])

  return data
}

export { useLanguage }
